import './CatalogItem.scss';
import {changeSidebarPane, NodeDefinition} from "../editorSlice";
import * as React from "react";
import { useAppDispatch } from '../../../hooks/hooks';

interface Props {
    title: string;
    type: string;
    icon: any;
    model: NodeDefinition ;
}

const accentsMap = new Map([
    ["_", "\\s|\\."],
    ["A", "Á|À|Ã|Â|Ä"],
    ["a", "á|à|ã|â|ä"],
    ["E", "É|È|Ê|Ë"],
    ["e", "é|è|ê|ë"],
    ["I", "Í|Ì|Î|Ï"],
    ["i", "í|ì|î|ï"],
    ["O", "Ó|Ò|Ô|Õ|Ö"],
    ["o", "ó|ò|ô|õ|ö"],
    ["U", "Ú|Ù|Û|Ü"],
    ["u", "ú|ù|û|ü"],
    ["C", "Ç"],
    ["c", "ç"],
    ["N", "Ñ"],
    ["n", "ñ"]
]);
// @ts-ignore
const reducer = (acc: string, [key]: any) => acc.replace(new RegExp(accentsMap.get(key), "g"), key);
// @ts-ignore
export const slugify = (text: string) => [...accentsMap].reduce(reducer, text.trim().toLowerCase());

export const CatalogItem = ({title, type, icon, model}: Props) => {

    const dispatch = useAppDispatch();

    return <div
        className={'catalog-item m-0 p-1 ' + ('kind__' + model.kind) +  ' col-12 __list'}
        draggable={true}
        onDragStart={(e) => {
            // console.log('drag item, model', model)
            e.dataTransfer.setData('storm-diagram-node', JSON.stringify({
                ...model,
                type,
                icon
            }));
        }}>
        <div className={"flex align-content-center justify-content-center align-items-center"}>
            <div className={"icon " + ('kind__' + model.kind)}>
                <img src={model.icon} alt=""
                     onError={({currentTarget}) => {
                         currentTarget.onerror = null; // prevents looping
                         currentTarget.src = "/images/connector.svg";
                     }}
                />
            </div>
            <div className="title"><span>{title}</span></div>
            <div style={{verticalAlign: "middle", color: "#007eae"}}
                className="info-icon"
                onClick={() => {
                    dispatch(
                        changeSidebarPane({ pane: "documentation", arg: {name: model.name, description: model.description}})
                    );
                }}
                >
                <span><i className="pi pi-info-circle"/></span>
            </div>
        </div>
    </div>
}
